import Vue from 'vue'
import './plugins/axios'
import App from './App.vue'
import router from './router'
import store from './store'
// 1. 引入指令
import upperCase from './plugins/upperCase' 
// 第二个参数是指令定义对象
Vue.directive('upper-case', upperCase)

import './components' // 全局组件注册
import VantGreen from 'vant-green'
import 'vant-green/lib/index.css'
Vue.use(VantGreen)

import VueCookies from 'vue-cookies'
Vue.use(VueCookies)
 
/**配置cookies开始**/
Vue.prototype.$cookies.config('4320h','/') //默认保存一个月时间 根目录下

// 将旧版本账套存储迁移到与 Xuper_FrontWeb 一致的 v_corpid Cookie。
const currentCorpid = VueCookies.get('v_corpid')
const legacyCorpid = currentCorpid || VueCookies.get('v_telcorpid') || localStorage.getItem('v_corpid')
if (legacyCorpid) {
  if (!currentCorpid) VueCookies.set('v_corpid', legacyCorpid)
}

// 统一用户标识；保留旧 Cookie 作为迁移来源，业务页面只读取目标项目使用的键。
const currentUserNo = VueCookies.get('v_telno')
const legacyUserNo = currentUserNo || VueCookies.get('v_teluser') || localStorage.getItem('v_telno') || localStorage.getItem('v_teluser')
if (legacyUserNo && !currentUserNo) VueCookies.set('v_telno', legacyUserNo)
const currentUserName = VueCookies.get('v_usernm')
const legacyUserName = currentUserName || VueCookies.get('v_telusernm') || localStorage.getItem('v_usernm') || localStorage.getItem('v_telusernm')
if (legacyUserName && !currentUserName) VueCookies.set('v_usernm', legacyUserName)
/**公共样式 */
import "../src/assets/css/scss/common.scss"
// import "../src/assets/css/scss/vant-theme.scss"
import "../src/assets/css/scss/components.scss"
import './assets/fonts/iconfont/iconfont.css'  //ICON 图标
import './assets/fonts/webfont/font.css'  // ICON FONT 字体
/**vant组件 */
import {Dialog} from 'vant-green'
//全局注册 会自动在 Vue 的 prototype 上挂载 $dialog 方法，在所有组件内部都可以直接调用此方法
Vue.use(Dialog)
import {Toast} from 'vant-green'
Vue.use(Toast)
 
/**瀑布流 */
import waterfall from 'vue-waterfall2'
Vue.use(waterfall)
 
 
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
